import _getIterator from "@babel/runtime-corejs3/core-js/get-iterator";
import _objectSpread from "@babel/runtime-corejs3/helpers/objectSpread2";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _extends from "@babel/runtime-corejs3/helpers/extends";
// The guts of the router implementation.
import { Location, parseSearch, replaceParams, matchPath, ParamsContext, navigate, mapNamedRoutes, SplashPage, PageLoader } from "./internal"; // Definitions of the core param types.

var coreParamTypes = {
  Int: {
    constraint: /\d+/,
    transform: Number
  }
};

var Route = function Route() {
  return null;
};

var Router = function Router(props) {
  return React.createElement(Location, null, function (locationContext) {
    return React.createElement(RouterImpl, _extends({}, locationContext, props));
  });
};
/**
 * Pages can be imported automatically or manually. Automatic imports are actually
 * objects and take the following form (which we call a 'spec'):
 *
 *   const WhateverPage = {
 *     name: 'WhateverPage',
 *     loader: () => import('src/pages/WhateverPage')
 *   }
 *
 * Manual imports simply load the page:
 *
 *   import WhateverPage from 'src/pages/WhateverPage'
 *
 * Before passing a "page" to the PageLoader, we will normalize the manually
 * imported version into a spec. */


var normalizePage = function normalizePage(specOrPage) {
  if (specOrPage.loader) {
    // Already a spec, just return it.
    return specOrPage;
  } else {
    // Wrap the Page in a fresh spec, and put it in a promise to emulate
    // an async module import.
    return {
      name: specOrPage.name,
      loader: function () {
        var _loader = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", {
                    default: specOrPage
                  });

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function loader() {
          return _loader.apply(this, arguments);
        }

        return loader;
      }()
    };
  }
};

var DEFAULT_PAGE_LOADING_DELAY = 1000; // milliseconds

var RouterImpl = function RouterImpl(_ref) {
  var pathname = _ref.pathname,
      search = _ref.search,
      paramTypes = _ref.paramTypes,
      _ref$pageLoadingDelay = _ref.pageLoadingDelay,
      pageLoadingDelay = _ref$pageLoadingDelay === void 0 ? DEFAULT_PAGE_LOADING_DELAY : _ref$pageLoadingDelay,
      children = _ref.children;
  var routes = React.Children.toArray(children);
  mapNamedRoutes(routes);
  var NotFoundPage;

  var allParamTypes = _objectSpread({}, coreParamTypes, {}, paramTypes);

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _getIterator(routes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var route = _step.value;
      var _route$props = route.props,
          path = _route$props.path,
          Page = _route$props.page,
          redirect = _route$props.redirect,
          notfound = _route$props.notfound;

      if (notfound) {
        NotFoundPage = Page;
        continue;
      }

      var _matchPath = matchPath(path, pathname, allParamTypes),
          match = _matchPath.match,
          pathParams = _matchPath.params;

      if (match) {
        var searchParams = parseSearch(search);

        var allParams = _objectSpread({}, pathParams, {}, searchParams);

        if (redirect) {
          var newPath = replaceParams(redirect, pathParams);
          navigate(newPath);
          return React.createElement(RouterImpl, {
            pathname: newPath,
            search: search
          }, children);
        } else {
          return React.createElement(ParamsContext.Provider, {
            value: allParams
          }, React.createElement(PageLoader, {
            spec: normalizePage(Page),
            delay: pageLoadingDelay,
            params: allParams
          }));
        }
      }
    } // If the router is being used in a Redwood app and only the notfound page is
    // specified, show the Redwood splash page.

  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (routes.length === 1 && NotFoundPage) {
    var isRedwood = typeof __REDWOOD__ !== 'undefined';
    return React.createElement(SplashPage, {
      isRedwood: isRedwood
    });
  }

  return React.createElement(ParamsContext.Provider, {
    value: {}
  }, React.createElement(PageLoader, {
    spec: normalizePage(NotFoundPage)
  }));
};

export { Router, Route };